import { render, staticRenderFns } from "./InheritanceHeirPage.vue?vue&type=template&id=110d7c10&scoped=true"
import script from "./InheritanceHeirPage.vue?vue&type=script&lang=js"
export * from "./InheritanceHeirPage.vue?vue&type=script&lang=js"
import style0 from "./InheritanceHeirPage.vue?vue&type=style&index=0&id=110d7c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110d7c10",
  null
  
)

export default component.exports